import { State } from '../stores/global';

let newNotification = false;
let newMeeting = false;
export function getNotificationItems(user: State['user']) {
  const isEmailVerified = Boolean(user?.valid?.email);
  const isPhoneVerified = Boolean(user?.valid?.phone);
  const isEmailOrPhoneVerified = isEmailVerified || isPhoneVerified;
  const showNotification = user && !isEmailOrPhoneVerified;

  return {
    isEmailOrPhoneVerified,
    showNotification,
  };
}

export function setNewNotification(state: boolean) {
  newNotification = state;
}

export function getNewNotification() {
  return {
    newNotification,
  };
}

export function setNewMeeting(state: boolean) {
  newMeeting = state;
}

export function getNewMeeting() {
  return {
    newMeeting,
  };
}
